

const BadgesSideWidget = () => {
    return <>
        <h2>Badges widget</h2>
        
    </>
}

export default BadgesSideWidget;